import React from 'react';
import { valueForKeyPath as v } from '../../../utils.jsx';

class SectionForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      _id: v(props, 'section._id', ''),
      parent: v(props, 'section.parent', ''),
      name: v(props, 'section.name', ''),
      show: v(props, 'section.show', true),
      url: v(props, 'section.url', ''),
      uniqid: v(props, 'section.uniqid', ''),
      redirecturl: v(props, 'section.redirecturl', ''),
      perex: v(props, 'section.perex', ''),
      order: v(props, 'section.order', ''),
    };

    this.onChangeShow = this.onChangeShow.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  onChangeShow(event) {
    this.setState({ show: event.target.checked });
  }

  onChange(event) {
    if (event.target.name in this.state) {
      const chst = {};
      if (event.target.name === 'url') {
        let url = event.target.value;
        url = url.replace(/^\/+(.+)$/g, '$1');
        url = url.replace(/[^a-zA-Z0-9\-\/]/g, '');
        url = url.replace(/\/\//g, '/');
        chst[event.target.name] = url;
      } else if (event.target.name === 'uniqid') {
        let uniqid = event.target.value;
        uniqid = uniqid.replace(/[^a-zA-Z0-9\-.]/g, '');
        chst[event.target.name] = uniqid;
      } else {
        chst[event.target.name] = event.target.value;
      }
      this.setState(chst);
    }
  }

  onSave() {
    const savedata = {
      _id: this.state._id,
      name: this.state.name,
      url: this.state.url,
      parent: this.state.parent,
      show: this.state.show,
      perex: this.state.perex ? this.state.perex : null,
      redirecturl: this.state.redirecturl ? this.state.redirecturl : null,
      order: parseFloat(this.state.order)
    };
    if (this.state.uniqid) {
      savedata.uniqid = this.state.uniqid;
    }
    this.props.onSave(savedata);
  }

  onDelete() {
    if (window.confirm('Vymazať menu?')) {
      this.props.onDelete(this.state._id);
    }
  }

  render() {
    return (
      <div className="form">
        <div className="modal-body">
          <div className="form-group">
            <label htmlFor="content-dialog-name" className="title">
              Názov
            </label>
            <input
              type="text"
              placeholder="Vyplňte názov"
              className="form-control"
              onChange={this.onChange}
              name="name"
              value={this.state.name}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="content-dialog-url" className="title">
              URL adresa
            </label>
            <input
              type="text"
              placeholder="/"
              className="form-control"
              onChange={this.onChange}
              name="url"
              value={this.state.url}
            />
          </div>
          <div className="form-group">
            <label htmlFor="content-dialog-url" className="title">
              Identifikátor
            </label>
            <input
              type="text"
              placeholder="(nepovinné)"
              className="form-control"
              onChange={this.onChange}
              name="uniqid"
              value={this.state.uniqid}
            />
          </div>
          <div className="form-group">
            <label className="title" htmlFor="perex">
              Perex
            </label>
            <textarea
              ref="perex"
              id="perex"
              className="form-control"
              placeholder="(nepovinné)"
              rows="2"
              cols=""
              onChange={this.onChange}
              name="perex"
              value={this.state.perex}
            />
          </div>
          <div className="form-group">
            <label htmlFor="content-dialog-redirecturl" className="title">
              URL presmerovanie
            </label>
            <input
              type="text"
              placeholder="(nepovinné)"
              className="form-control"
              onChange={this.onChange}
              name="redirecturl"
              value={this.state.redirecturl}
            />
          </div>
          <div className="form-group">
            <label htmlFor="order">Poradie</label>
            <input
              type="text"
              className="form-control"
              onChange={this.onChange}
              name="order"
              value={this.state.order}
              placeholder="(nepovinné)"
            />
          </div>
          <div className="checkbox">
            <label>
              <input
                type="checkbox"
                onChange={this.onChangeShow}
                checked={this.state.show}
              />
              Zobraziť
            </label>
          </div>
        </div>
        <div className="modal-footer">
          {this.state._id ? (
            <button
              type="button"
              className="btn btn-danger pull-left"
              onClick={this.onDelete}
            >
              <span className="fa fa-trash" />&nbsp;Odstrániť
            </button>
          ) : null}
          <button
            type="submit"
            className="btn btn-primary"
            onClick={this.onSave}
            disabled={this.props.loading}
          >
            <span className="fa fa-floppy-o" />&nbsp;Uložiť
          </button>
        </div>
      </div>
    );
  }
}

export default SectionForm;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/SectionForm.jsx